import { deleteData, getData, postData } from '../../../utils/service';
import { AIOsResponseEvent, DeleteAOIEvent, Events, SubmitAOIEvent } from './events';
import { Context } from './types';

import { AOISToOptions, getAOIS, handleAOIResponse, specialtiesToOptions } from './utils';

interface XstateInput {
  input: { context: Context; event: Events };
}
const AOI_ROUTE_NAME = 'aois';
const AOI_SPEC_NAME = 'aoisSpec';
const AOI_OPTION_NAME = 'aoisOptions';
const BASE_URL = 'areas-of-interest/';

export const AOI_ROUTES = {
  get: `/${BASE_URL}provider/{providerId}`,
  post: `/${BASE_URL}provider`,
  delete: `/${BASE_URL}provider/{id}`,
};
export const AOI_API_CALLS = {
  get: async (props: XstateInput): Promise<AIOsResponseEvent> => {
    return await getData(AOI_ROUTE_NAME, {
      pathParams: {
        providerId: props.input.context.providerId.toString(),
      },
      transformResponse: getAOIS,
    });
  },
  create: async (props: XstateInput): Promise<AIOsResponseEvent> => {
    // [CQ3] _aoiBuffer is staged via the setAoiBuffer assign action before this actor runs,
    // so we no longer mutate props.input.context here.
    const event = props.input.event as SubmitAOIEvent;
    const existingIds = props.input.context.aois.map((aoi) => aoi.id.toString());
    const ids = [event.values.aoiSelect.value, ...existingIds];
    return await postData(AOI_ROUTE_NAME, {
      data: ids,
      transformResponse: handleAOIResponse,
    });
  },
  delete: async (props: XstateInput) => {
    const event = props.input.event as DeleteAOIEvent;
    return await deleteData(AOI_ROUTE_NAME, {
      pathParams: { id: event.payload.id.toString() },
    });
  },
};
export const AOI_SPEC_ROUTES = {
  get: `/${BASE_URL}specialties/{providerCategoryId}`,
};
export const AOI_SPEC_OPTIONS_CALLS = {
  get: async (props: XstateInput): Promise<AIOsResponseEvent> => {
    return await getData(AOI_SPEC_NAME, {
      pathParams: {
        providerCategoryId: props.input.context.providerCategoryId.toString(),
      },
      transformResponse: specialtiesToOptions,
    });
  },
};
export const AOI_OPTIONS_ROUTES = {
  get: `/${BASE_URL}{specialtiesId}`,
};
export const AOI_OPTIONS_CALLS = {
  get: async (props: XstateInput): Promise<AIOsResponseEvent> => {
    return await getData(AOI_OPTION_NAME, {
      pathParams: {
        specialtiesId: props.input.context.specialtiesId,
      },
      transformResponse: AOISToOptions,
    });
  },
};
